import { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import RelatoriosTabela from './RelatorioTabela';
import { useHistory } from "react-router-dom";
import RelatoriosService from "../../services/RelatoriosService";
import { IEsteira } from "../../interfaces/IRelatorioCliente";
import { Tipo } from "./Relatorio";
import { useAuth } from "../../contexts/AuthProvider";

/*Tradução */
import './../../../i18n/config';
import { useTranslation } from 'react-i18next';

export function limparDados() {
    localStorage.setItem(`${Tipo.Empresa}`, JSON.stringify(null));
    localStorage.setItem(`${Tipo.DataInicial}`, JSON.stringify(null));
    localStorage.setItem(`${Tipo.DataFinal}`, JSON.stringify(null));
}

export function pegarEsteiraSelecionada(): IEsteira | undefined {
    const json = localStorage.getItem(`${Tipo.Esteira}`) ?? "";
    const esteira = (json ? JSON.parse(json) : {}) as IEsteira;

    return esteira;
}

function RelatorioSelecionarCliente() {
    const intl = useIntl();
    const { classes } = useLayout();
    const { usuario } = useAuth();
    const [esteiras, setEsteiras] = useState<IEsteira[]>([]);
    const [carregado, setCarregado] = useState<boolean>(false);
    const history = useHistory();
    const { t } = useTranslation();
    const columns = [
        {
            name: t('Cliente'),
            selector: (row: IEsteira) => row['razaoSocial'],
            sortable: true,
        },
        {
            name: t('CNPJ'),
            selector: (row: IEsteira) => row['cnpj'],
            sortable: true
        },
        {
            name: t('Situação Cadastral'),
            selector: (row: IEsteira) => row['situacaoCadastral'],
            sortable: true
        }
    ];

    useEffect(() => {
        async function preCarregar() {
            if (usuario?.perfil === 'Analista') {
                await RelatoriosService.obterEmpresasPorUsuarioID(usuario.id, x => setEsteiras(x));
            } else {
                if (usuario?.clienteID) {
                    await RelatoriosService.obterEmpresasPorClienteID(usuario.clienteID, x => setEsteiras(x));
                }
            }

            setCarregado(true);
        }

        limparDados();
        preCarregar()
    }, [])

    return <>
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: t('MENU.RELATORIOS') })}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
            </div>
        </div>

        {
            carregado ?
                <RelatoriosTabela colunas={columns} itens={esteiras} acaoTocarLinha={e => {
                    history.push(`relatorio/${e.empresaID}`);
                    localStorage.setItem(`${Tipo.Relatorio}`, e?.razaoSocial ?? "");
                    localStorage.setItem(`${Tipo.Esteira}`, JSON.stringify(e));
                }} />
                : <p>{t('Carregando...')}</p>
        }
    </>
};

export default RelatorioSelecionarCliente;